import { localStorageService } from '../helpers'
import { ROUTE_PATH } from '../helpers'
import { getState } from '../store'
import { logout, unsetAuthenticated } from '../store/actions'
import { store } from 'store'
export const controller = () => {
  const funcParseObj = role => {
    if (role && typeof role === 'string') {
      const objRole = JSON.parse(role)
      return objRole
    }
    return role
  }
  return {
    redirectToHomePage: props => {
      return props.history.push(ROUTE_PATH.HOME.LINK)
    },
    redirectToLogin: () => {
      return store.dispatch(logout())
    },
    checkRole: role => {
      const objRole = funcParseObj(role)
      const countRole = 1
      if (objRole && objRole.length === countRole) {
        return {
          roleSingle: true,
          roles: objRole,
        }
      } else {
        return {
          roleSingle: false,
          roles: objRole,
        }
      }
    },
    filterRole: (array, func) => {
      return array.filter(func)
    },
    funcPrevPath: (locationPath, path) => {
      return locationPath.includes(path)
    },
    funcCheckPrevPath: (locationPath, path) => {
      return locationPath.indexOf(path)
    },
    asset(allowRoles = []) {
      const user = getState().user

      if (user) {
        const { roles = [] } = user
        if (roles.length <= 0) {
          return false
        }

        const findRoleAllowed = Object.keys(allowRoles).find(
          acr => rolesObj[acr]
        )

        if (findRoleAllowed) {
          const result = allowRoles[findRoleAllowed]
          if (result instanceof Function) {
            return result()
          }

          return result
        }
      }

      return false
    },
  }
}

export const rolesObj = {
  systemadmin: 2,
  admin: 3,
  user: 4,
  risk: 7,
  purchaser: 8,
  tec: 10,
  approver: 9,
  observer: 11,
  supplierAdmin: 5,
}

export const pathAssetEmail = {
  supplierManagement: 'supplier-management-information-edit',
  sourcingCompareEvent: 'sourcing-compare-event',
  sourcingDetail: 'sourcing-detail-form-supplier',
}

export const host = {
  hostBuyerDev: 'buyer.dev.astrosystem.co',
  hostBuyerSTG: 'buyer.astrosystem.co',
  hostBuyerUat: 'buyer.uat.astrosystem.co',
  hostBuyerProd: 'buyer.tspacesourcing.com',
}

export const menuSideBar = {
  home: 'Home',
  companyProfile: 'Company Profile',
  userManagement: 'User Management',
  supplierManagement: 'Supplier Management',
  supplierDiscovery: 'Supplier Discovery',
  riskManagement: 'Risk Management',
  regulatory: 'Regulatory',
  sustainabilityManagement: 'Sustainability Management',
  comprehensiveAssessmentManagement: 'Comprehensive Assessment Management',
  Sourcing: 'Sourcing',
}
